export default "__VITE_ASSET__3KiLmFjK__"